//API URL
// export const API_URL = "http://13.49.148.153:8000"
// export const API_URL = "https://dignizant.com:2900";

export const API_URL = "https://api.greencert.se";
// export const API_URL = "http://192.168.29.106:2800";
